export function supportsWorkspaceScreen(viewportWidth: number, screenWidth: number): boolean {
  // Page zoom shrinks the viewport, but must not turn a desktop into an unsupported phone.
  // Use CSS screen pixels, never devicePixelRatio (which also includes Retina/OS scaling).
  return viewportWidth >= 768 || screenWidth >= 768;
}
